export default "__VITE_PUBLIC_ASSET__6167e083__"